var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatusAlertWarning = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16.002,
  viewBox: "0 0 16 16.002",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E3C33A",
  d: "M16 7.863a8.12 8.12 0 0 1-8 8.138 7.88 7.88 0 0 1-8-7.86A8.12 8.12 0 0 1 8 0a7.88 7.88 0 0 1 8 7.862z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2.5,
  d: "M8 7.432V3.34"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 3,
  d: "M7.993 12.34a.18.18 0 0 0-.175.186c.004.1.085.178.184.179h0a.18.18 0 0 0 .175-.186.184.184 0 0 0-.177-.178h-.004"
})))));
export { SvgStatusAlertWarning as ReactComponent };
export default __webpack_public_path__ + "assets/images/status-alert-warning.svg";